const createUpsertBatchDetails = require('../batch/upsert-batch-details')
const { fsShipmentDateParser } = require('../shipment/tools/safe-date-parser')

function createBatchHelpers ({ mainApi, logger }) {
  const upsertBatchDetails = createUpsertBatchDetails({ mainApi, logger })

  async function fromRmsLines (lines = []) {
    for (const line of lines) {
      if (!line || !line.batchNumber || !line.expiryDate) continue
      await upsertBatchDetails({
        skuCode: line.productId,
        batchNo: line.batchNumber,
        manufacturer: line.manufacturer,
        expiry: new Date(fsShipmentDateParser(line.expiryDate)).toJSON()
      })
    }
  }

  return { fromRmsLines }
}

module.exports = createBatchHelpers
